const template = `
<div class="own-profit-outer-container">
	<div class="own-profit-container">

		<div class="own-profit-top">
			<div class="own-profit-top-bar">
				<div class="stripes"></div>
				<button type="button" class="close"></button>
			</div>
		</div>

    <!-- loader--visible -->
		<div class="own-profit-loader loader loader--with-light-bg loader--cover">
			<div class="loader__inner">
				<div class="spinner"></div>
				<h1>&nbsp;</h1>
			</div>
		</div>

		<div class="scroll-container">
			<div class="content-container">
        <h3 class="own-profit-header">Sätt din vinstvärdering i procent</h3>
        <p class="own-profit-extra-info">Summan av alla hästar i loppet måste vara 100%</p>
        <div class="own-profit-content"></div>
			</div>
		</div>
	</div>
</div>
`;

export default template;
